
import { defineComponent, ref, watch } from 'vue';
import { UseRequest } from '@/utils/useRequest'
import { getAllPlayers } from '@/api/api'
import { getAllPlayersParamType } from '@/types/api'

import Players from "@/components/Players.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import Error from "@/components/Error.vue";


export default defineComponent({
  components: {
    Players,
    ProgressBar,
    Error
  },
  setup() {

    const searchText = ref<string>('')
    const previousSearchText = ref<string>('')
    const page = ref<number>(1)
    const players = new UseRequest(getAllPlayers)

    const search: (page?: number) => void = (page = 1): void => {

      if (!searchText.value.length) return

      players.createRequest<getAllPlayersParamType>({
        search: searchText.value,
        page: page
      })
      .then(() => {
        page = players.result.value.meta.current_page
      })
      .then(() => {
        previousSearchText.value = searchText.value
      })
    }

    watch(page, () => search(page.value))

    const blurTitle = 'Search the stats of NBA players'
    const focusTitle = 'Which player do you want to know about ?'
    const searchTextParagraph = ref<string>(blurTitle)
    const focus = () => searchTextParagraph.value = focusTitle
    const blur = () => searchTextParagraph.value = blurTitle

    return {
      searchTextParagraph,
      searchText,
      previousSearchText,
      page,
      search,
      players,
      focus,
      blur
    }
  }
});
